// library imports         
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setApiTimestamp } from "_core/slices/datas/TransactionSlice";

const AdminInquiryLogListApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/inquiry_log_list";

    const ExecAdminInquiryLogListApi = async (requestParams) => {
        let response = null;
        let error = null;

        try {
            response = await ApiRequest({ url, requestParams});
        } catch (e) {
            error = e;
        }

        if (response !== null && response.error_code === 0) {
            dispatch(setApiTimestamp(response['now_time']));
        }
        return { response, error };
    };

    return ExecAdminInquiryLogListApi;
};

export default AdminInquiryLogListApi;
